import yup from 'utils/yup';

export const emailTemplateValidationSchema = yup.object().shape({
  subject: yup.string().trim().required('Subject is required').nullable(),
  body: yup.string().trim().required('Message is required').nullable(),
  name: yup
    .string()
    .trim()
    .nullable()
    .when('isNewTemplate', {
      is: true,
      then: (schema: any) => schema.required('Template Name is required'),
      otherwise: (schema: any) => schema.notRequired(),
    }),
});
